export const APPROVAL_POLL_INTERVAL_MILLISECONDS = 10_000
export const TRADE_POLL_INTERVAL_MILLISECONDS = 10_000
